import { Action } from 'redux';

import { GetCredentialEncryptionKeyRequest, GetCredentialEncryptionKeyRequestSucceeded } from '~src/bootstrap/redux/actions/AppActionTypes';
import { isActionFactory } from '~src/bootstrap/redux/actions/isActionFactory';

import { IGetSiteEncryptionDataKeyResult } from '../models/CredentialEncryptionModels';

export interface GetCredentialEncryptionKeyRequestAction extends Action {}

export function getCredentialEncryptionKeyRequest(): GetCredentialEncryptionKeyRequestAction {
  return {
    type: GetCredentialEncryptionKeyRequest
  };
}

export const isGetCredentialEncryptionKeyRequest = isActionFactory<GetCredentialEncryptionKeyRequestAction>(GetCredentialEncryptionKeyRequest);

export interface GetCredentialEncryptionKeyRequestSucceededAction extends Action {
    readonly encryptionKey: IGetSiteEncryptionDataKeyResult;
  }

  export function getCredentialEncryptionKeyRequestSucceeded(encryptionKey: IGetSiteEncryptionDataKeyResult): GetCredentialEncryptionKeyRequestSucceededAction {
    return {
      type: GetCredentialEncryptionKeyRequestSucceeded,
      encryptionKey
    };
  }

  export const isGetCredentialEncryptionKeyRequestSucceeded = isActionFactory<GetCredentialEncryptionKeyRequestSucceededAction>(GetCredentialEncryptionKeyRequestSucceeded);